// Sets a timeout on the promise and returns the result of the promise or undefined if the timeout is reached
export async function timeoutPromise<T>(
  promise: Promise<T>,
  timeoutMs: number,
  timeoutCallback?: () => void,
): Promise<T | undefined> {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  const promiseWithTimeout = new Promise<undefined>((resolve) => {
    timeoutId = setTimeout(() => {
      timeoutCallback?.();
      resolve(undefined);
    }, timeoutMs);
  });

  const result = await Promise.race([promise, promiseWithTimeout]);

  clearTimeout(timeoutId);
  return result;
}
